import Icon from "components/templatesComponents/Icon";
import PropTypes from "prop-types";
import React from "react";

const WebcallbackIcon = (props) => {
  const { iconDSFR, disabled = false, handleChange } = props;

  return (
    <Icon
      iconDSFR={iconDSFR}
      className="fr-mt-4w"
      sx={{
        height: "fit-content",
        cursor: disabled ? "inherit" : "pointer",
        color: disabled ? "inherit" : "primary.main",
      }}
      onClick={disabled ? undefined : handleChange}
    />
  );
};

WebcallbackIcon.propTypes = {
  iconDSFR: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
};

export default WebcallbackIcon;
